module.exports = __webpack_public_path__ + "img/bracket-8.9b0cdf4e.svg";